import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/store/orders",
  "alias": [],
  "documento": "pos-store",
  "acceso": "sesion",
  "filas": [
    "111"
  ],
  "cita": "Areas/POS_Store/Controllers/OrdersController.cs"
} satisfies RutaProd;
